import React from 'react';

const Calendar = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4828_12142)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.83337 8.00004C1.83337 4.59428 4.59428 1.83337 8.00004 1.83337C9.12409 1.83337 10.1765 2.13366 11.083 2.65806C11.322 2.79633 11.6279 2.71465 11.7662 2.47562C11.9045 2.23659 11.8228 1.93072 11.5837 1.79245C10.5291 1.18238 9.30457 0.833374 8.00004 0.833374C4.042 0.833374 0.833374 4.042 0.833374 8.00004C0.833374 11.9581 4.042 15.1667 8.00004 15.1667C11.9581 15.1667 15.1667 11.9581 15.1667 8.00004C15.1667 7.1185 15.0073 6.27305 14.7153 5.49169C14.6187 5.23302 14.3306 5.10168 14.0719 5.19834C13.8133 5.295 13.6819 5.58305 13.7786 5.84173C14.0294 6.51282 14.1667 7.23982 14.1667 8.00004C14.1667 11.4058 11.4058 14.1667 8.00004 14.1667C4.59428 14.1667 1.83337 11.4058 1.83337 8.00004ZM14.3717 3.00119C14.5564 2.79594 14.5398 2.47979 14.3345 2.29506C14.1293 2.11034 13.8131 2.12697 13.6284 2.33223L8.47001 8.06378C8.1747 8.39191 7.67474 8.43281 7.33002 8.15704L4.97907 6.27628C4.76344 6.10377 4.4488 6.13873 4.27629 6.35436C4.10379 6.56999 4.13875 6.88464 4.35438 7.05715L6.70533 8.9379C7.4637 9.5446 8.56362 9.45463 9.21331 8.73275L14.3717 3.00119Z"
          fill="#226FE3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4828_12142">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Calendar;
